import { render, staticRenderFns } from "./EmployeesRoute.vue?vue&type=template&id=3c51a7d2&scoped=true&"
import script from "./EmployeesRoute.vue?vue&type=script&lang=js&"
export * from "./EmployeesRoute.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesRoute.vue?vue&type=style&index=0&id=3c51a7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c51a7d2",
  null
  
)

export default component.exports